import React from "react";
import { ImpersonateTab } from "./impersonate-tab";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { HelpCircle, LogOut, Home } from "lucide-react";
import { useAuth } from "./auth-routes-provider";
import {
  useSetSupervisorMode,
  useSupervisorMode,
} from "./supervisor-mode-provider";
import { ThemesHelperMenuItem } from "./themes-helper-menu-item";
import { GuidelinesHelperMenuItem } from "./guidelines-helper-menu-item";
import { KeyboardShortcutsHelpModalModern } from "./keyboard-shortcuts-help-modal-modern";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "./theme-toggle";
import { appUrls } from "../utils/use-get-page-url";

export const OutletWithMenu: React.FC = () => {
  const auth = useAuth();
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const isSupervisorMode = useSupervisorMode();
  const setSupervisorMode = useSetSupervisorMode();
  const [showHelpModal, setShowHelpModal] = React.useState(false);

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <>
      <ImpersonateTab />
      <header className="sticky top-0 z-50 bg-background">
        <div className="flex h-14 items-center px-4 gap-4">
          <div className="flex items-center gap-3 flex-1">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(appUrls.home)}
              title="Home"
            >
              <Home className="h-5 w-5" />
            </Button>
            <ThemesHelperMenuItem />
            <GuidelinesHelperMenuItem />
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant={isSupervisorMode ? "default" : "outline"}
              size="sm"
              onClick={() => setSupervisorMode(!isSupervisorMode)}
              className={isSupervisorMode ? "bg-orange-600 hover:bg-orange-700" : ""}
            >
              {isSupervisorMode ? "Disable" : "Enable"} supervisor mode
            </Button>

            {auth && (
              <>
                <ThemeToggle />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setShowHelpModal(true)}
                  title="Keyboard shortcuts"
                >
                  <HelpCircle className="h-5 w-5" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={handleLogout}
                  title="Logout"
                >
                  <LogOut className="h-5 w-5" />
                </Button>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="p-2 min-h-[calc(100vh-3.5rem)] bg-background">
        <Outlet />
      </main>

      <KeyboardShortcutsHelpModalModern
        open={showHelpModal}
        onClose={() => setShowHelpModal(false)}
      />
    </>
  );
};
